export const IncomingCallsMap = {
  GET_ALL_COLD_LEADS_START: "GET_ALL_COLD_LEADS_START",
  GET_ALL_COLD_LEADS_SUCCESS: "GET_ALL_COLD_LEADS_SUCCESS",
  GET_ALL_COLD_LEADS_ERROR: "GET_ALL_COLD_LEADS_ERROR",
  SEARCH_TEXT_CHANGE: "COLD_LEADS_SEARCH_TEXT_CHANGE",
  SET_COLD_LEADS_BATCH_NUMBER: "SET_COLD_LEADS_BATCH_NUMBER",
  GET_COLD_LEAD_START: "GET_COLD_LEAD_START",
  GET_COLD_LEAD_SUCCESS: "GET_COLD_LEAD_SUCCESS",
  GET_COLD_LEAD_ERROR: "GET_COLD_LEAD_ERROR",
  SET_AUDIO_TYPE: "COLD_LEADS_SET_AUDIO_TYPE",
  SET_DATE_FILTER: "COLD_LEADS_SET_DATE_FILTER",
  SET_FROM_DATE_FILTER: "INCOMING_CALLS_SET_FROM_DATE_FILTER",
  SET_TO_DATE_FILTER: "INCOMING_CALLS_SET_TO_DATE_FILTER",
  SET_LEAD_TYPE: "COLD_LEADS_SET_LEAD_TYPE",
  SET_CALL_OUTCOME_FILTER: "COLD_LEADS_SET_CALL_OUTCOME_FILTER",
  SET_LIMIT: "COLD_LEADS_SET_LIMIT",
  RESET_REFRESH_FLAG: "RESET_REFRESH_FLAG",
};

export const incomingCallsAction = {
  getAllIncomingCallsStart: () => ({
    type: IncomingCallsMap.GET_ALL_COLD_LEADS_START,
  }),
  getAllIncomingCallsSuccess: (payload) => ({
    type: IncomingCallsMap.GET_ALL_COLD_LEADS_SUCCESS,
    payload,
  }),
  getAllIncomingCallsError: () => ({
    type: IncomingCallsMap.GET_ALL_COLD_LEADS_ERROR,
  }),
  searchTextChange: (text) => ({
    type: IncomingCallsMap.SEARCH_TEXT_CHANGE,
    payload: text,
  }),
  setIncomingCallsBatchNumber: (batchNumber) => ({
    type: IncomingCallsMap.SET_COLD_LEADS_BATCH_NUMBER,
    payload: batchNumber,
  }),
  getIncomingCallStart: () => ({
    type: IncomingCallsMap.GET_COLD_LEAD_START,
  }),
  getIncomingCallSuccess: (payload) => ({
    type: IncomingCallsMap.GET_COLD_LEAD_SUCCESS,
    payload,
  }),
  getIncomingCallError: () => ({
    type: IncomingCallsMap.GET_COLD_LEAD_ERROR,
  }),
  setAudioType: (audioType) => ({
    type: IncomingCallsMap.SET_AUDIO_TYPE,
    payload: audioType,
  }),
  setDateFilter: (date) => ({
    type: IncomingCallsMap.SET_DATE_FILTER,
    payload: date,
  }),
  setFromDateFilter: (date) => ({
    type: IncomingCallsMap.SET_FROM_DATE_FILTER,
    payload: date,
  }),
  setToDateFilter: (date) => ({
    type: IncomingCallsMap.SET_TO_DATE_FILTER,
    payload: date,
  }),
  setLeadType: (leadType) => ({
    type: IncomingCallsMap.SET_LEAD_TYPE,
    payload: leadType,
  }),
  setCallOutcomeFilter: (callOutcome) => ({
    type: IncomingCallsMap.SET_CALL_OUTCOME_FILTER,
    payload: callOutcome,
  }),
  setLimit: (limit) => ({
    type: IncomingCallsMap.SET_LIMIT,
    payload: limit,
  }),
  resetRefreshFlag: () => ({
    type: IncomingCallsMap.RESET_REFRESH_FLAG,
  }),
};


